import { FaReact, FaNodeJs, FaHtml5, FaSass } from 'react-icons/fa'
import { IoLogoJavascript } from 'react-icons/io'
import { SiKotlin } from 'react-icons/si'
import { DiJava } from 'react-icons/di'
import { AiFillAndroid } from 'react-icons/ai'
import { ImGit } from 'react-icons/im'
// @ts-ignore
import React from 'react'

interface SkillsType {
  name: string
  icon: any
  link: string
}

export const AndroidSkillsData: SkillsType[] = [
  {
    name: 'Java',
    icon: <DiJava color="#ffffffdc" />,
    link: 'https://www.javascript.com/',
  },
  {
    name: 'Kotlin',
    icon: <SiKotlin color="#ffffffdc" />,
    link: 'https://www.typescriptlang.org/',
  },
]
